var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"items-action":_vm.tableAction}})],1)],1),(_vm.get_dialogMain.dialog)?_c('MainFormDialog',{attrs:{"model":_vm.object,"params":_vm.paramsDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }